import Vue from "vue";
import Router from "vue-router";
import routers from "./router/index";
import routersE from "./router/indexEmpty";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/tradeCenter",
      meta: {
        title: ""
      },
      component: resolve => require(["./views/warpper"], resolve),
      children: [...routers]
    },
    {
      path: "/warpperEmpty",
      // redirect:"/home",
      meta: {
        title: ""
      },
      component: resolve => require(["./views/wrapperEmpty"], resolve),
      children: [...routersE]
    },
    {
      path: "/wrapperFooter",
      // redirect:"/home",
      meta: {
        title: ""
      },
      component: resolve => require(["./views/wrapperFooter"], resolve),
      children: [
        {
          path: "/memberCompany/detail",
          meta: {
            title: "首页"
            // keepAlive: true
          },
          component: resolve =>
            require(["./views/memberCompany/detail"], resolve)
        },
        {
          path: "/memberCompany/about",
          meta: {
            title: "关于"
            // keepAlive: true
          },
          component: resolve =>
            require(["./views/memberCompany/about"], resolve)
        },
        {
          path: "/memberCompany/service",
          meta: {
            title: "服务"
            // keepAlive: true
          },
          component: resolve =>
            require(["./views/memberCompany/service"], resolve)
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.js